import { render, staticRenderFns } from "./AuthorMine.vue?vue&type=template&id=1d39b614&scoped=true"
import script from "./AuthorMine.vue?vue&type=script&lang=js"
export * from "./AuthorMine.vue?vue&type=script&lang=js"
import style0 from "./AuthorMine.vue?vue&type=style&index=0&id=1d39b614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d39b614",
  null
  
)

export default component.exports